export var OptimizelyConfig = {
    Experiments: {
        BIG_5_PHARMACY_TEST: {
            expiration: '2021-11-01',
            variants: {
                control: 'Control_big_5',
                variant: 'Test_big_5',
            },
        },
    },
    Features: {
        MAIL_DELIVERY: {
            expiration: '2021-12-31',
            variables: {},
        },
        MAIL_SLA_ALERTING: {
            expiration: '2021-12-31',
            variables: {},
        },
        PATIENT_HEALTH_RECORD: {
            expiration: '2021-04-01',
            variables: {},
        },
    },
};
//# sourceMappingURL=optimizely.js.map